import { GetStaticProps, NextPage } from "next";

import { BluetoothLandingPage } from "@components/bluetooth-landing/BluetoothLandingPage";
import * as copy from "@data/nordic-landing/plCopy";

const ProgramowanieNordicNrfPage: NextPage = () => (
  <BluetoothLandingPage
    metadata={{
      title: copy.title,
      description: copy.description,
      canonicalPath: "/programowanie-nordic-nrf",
      lang: "pl",
      ogLocale: "pl_PL",
      structuredData: copy.structuredData,
      alternatePaths: {
        pl: "/programowanie-nordic-nrf",
        xDefault: "/programowanie-nordic-nrf",
      },
    }}
    heroCopy={copy.heroCopy}
    targetAudienceCopy={copy.targetAudienceCopy}
    valuePropositionCopy={copy.valuePropositionCopy}
    servicesCopy={copy.servicesCopy}
    processCopy={copy.processCopy}
    aboutUsCopy={copy.aboutUsCopy}
    faqCopy={copy.faqCopy}
    footerCopy={copy.footerCopy}
  />
);

export const getStaticProps: GetStaticProps = async () => ({
  props: {},
});

export default ProgramowanieNordicNrfPage;
